import ContentContext from "./ContentContext";

const ContentContextProvider = ({ value, children }) => {
  
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};

export default ContentContextProvider;